// extracted by mini-css-extract-plugin
export default {"heading":"heading--kAapE","subHeading":"subHeading--kAapE","headingContainer":"headingContainer--kAapE"};